import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { request } from "@/js/http/http_request";
import { getErrorData } from "@/js/forms.js";
import { formatPrice, roundToTwoDigit, getSymbolCurrency } from "@/js/currency/currencies.js";
import { listTerms, inboundDeliveryStatus, paymentState, paymentTypesWithCN, getPublicPaymentStateForAdmins } from "@/js/lists.ts";
import InboundDeliveryPaymentDetailsDialog from "@/components/inbound/InboundDeliveryPaymentDetailsDialog.vue";
import PaymentChangeStatusDialog from "@/components/payment/PaymentChangeStatusDialog.vue";
import PaymentLinkDrawer from "@/components/payment/AdminPaymentLinkDrawer.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
export default {
  name: "InboundDeliveryPaymentList",
  components: {
    InboundDeliveryPaymentDetailsDialog: InboundDeliveryPaymentDetailsDialog,
    PaymentChangeStatusDialog: PaymentChangeStatusDialog,
    PaymentLinkDrawer: PaymentLinkDrawer,
    Confirm: Confirm
  },
  props: {
    inboundDelivery: Object,
    fromOrders: Array | null,
    loggedUserData: Object
  },
  data: function data() {
    return {
      headers: [{
        text: "Status",
        value: "state",
        align: "left"
      }, {
        text: "Payment method",
        value: "type",
        align: "center"
      }, {
        text: "Amount",
        value: "amount",
        align: "center"
      }, {
        text: "Actions",
        value: "actions",
        align: "center"
      }],
      items: [],
      currentItem: null,
      inboundDeliveryPaymentDetailsDialogShown: false,
      paymentLinkDrawerShown: false,
      paymentDialogStatusShown: false,
      listTerms: listTerms,
      paymentState: paymentState,
      paymentTypesWithCN: paymentTypesWithCN
    };
  },
  computed: {
    isPaymentSucceeded: function isPaymentSucceeded() {
      return [paymentState.SUCCEEDED].includes(this.inboundDelivery.state);
    },
    isPaymentProcessing: function isPaymentProcessing() {
      return [paymentState.PROCESSING].includes(this.inboundDelivery.state);
    },
    isShowLaunchPayment: function isShowLaunchPayment() {
      return !this.isPaymentSucceeded && !this.isPaymentProcessing && inboundDeliveryStatus.filter(function (x) {
        return ["VALIDATED", "IN_PREPARATION", "DELIVERY", "DELIVERED"].includes(x.id);
      }).map(function (x) {
        return x.status;
      }).includes(this.inboundDelivery.status);
    },
    totalAmountCurrency: function totalAmountCurrency() {
      var amount = 0;
      this.items.forEach(function (x) {
        amount += x.amount;
      });
      return amount;
    },
    remainingAmount: function remainingAmount() {
      return roundToTwoDigit(this.inboundDelivery.totalAmountCurrencyIncludeShipping) - roundToTwoDigit(this.totalAmountCurrency);
    },
    hasAnyOldStockTransferAttached: function hasAnyOldStockTransferAttached() {
      var _this$fromOrders;
      return (_this$fromOrders = this.fromOrders) === null || _this$fromOrders === void 0 ? void 0 : _this$fromOrders.some(function (x) {
        return x.isPreventInvoice && x.isDestinationInbound;
      });
    },
    isForcedToHaveOnePaymentMax: function isForcedToHaveOnePaymentMax() {
      return true;
    }
  },
  created: function created() {
    var _this2 = this;
    if (this.inboundDelivery.payments) {
      this.items = this.inboundDelivery.payments.map(function (x) {
        return _objectSpread(_objectSpread({}, x), {}, {
          isLaunchingPayment: false,
          isSendPaymentLinkAvailable: _this2.isSendPaymentLinkAvailable(x)
        });
      });
    }
  },
  methods: {
    updatePayments: function updatePayments(payments) {
      var _this3 = this;
      this.items = payments.map(function (x) {
        return _objectSpread(_objectSpread({}, x), {}, {
          isLaunchingPayment: false,
          isSendPaymentLinkAvailable: _this3.isSendPaymentLinkAvailable(x)
        });
      });
    },
    fetchPayment: function fetchPayment(ack) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this = _this4;
              _context.next = 3;
              return request("/v1/payment/".concat(_this4.currentItem.id), "get", null, true, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to fetch payment.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 3:
              response = _context.sent;
              if (response) {
                ack(response.data.value);
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    refetchPayments: function refetchPayments(ack) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this5.fetchPayments();
            case 2:
              ack();
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchPayments: function fetchPayments() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return request("/v1/payment/all?inboundDeliveryId=".concat(_this6.inboundDelivery.id), "get", null, true, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to fetch payments.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 2:
              response = _context3.sent;
              if (response) {
                _this6.items = response.data.value.map(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    isLaunchingPayment: false,
                    isSendPaymentLinkAvailable: _this6.isSendPaymentLinkAvailable(x)
                  });
                });
                _this6.$emit("updateInboundDelivery", _this6.items);
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    isSendPaymentLinkAvailable: function isSendPaymentLinkAvailable(item) {
      var _item$link;
      return !((_item$link = item.link) !== null && _item$link !== void 0 && _item$link.id) && (!item.state || item.state !== paymentState.SUCCEEDED || item.state !== paymentState.PROCESSING) && this.isShowLaunchPayment;
    },
    isPaymentEditable: function isPaymentEditable(item) {
      var _item$link2;
      return !((_item$link2 = item.link) !== null && _item$link2 !== void 0 && _item$link2.id) && (!item.state || item.state !== paymentState.SUCCEEDED) && this.inboundDelivery.status !== inboundDeliveryStatus.find(function (x) {
        return x.id === "CANCELLED";
      }).status;
    },
    addPayment: function addPayment() {
      this.currentItem = null;
      this.inboundDeliveryPaymentDetailsDialogShown = true;
    },
    editPayment: function editPayment(item) {
      if (this.isPaymentEditable(item)) {
        this.currentItem = item;
        this.inboundDeliveryPaymentDetailsDialogShown = true;
      }
    },
    showPaymentStatusDialog: function showPaymentStatusDialog(value) {
      this.paymentDialogStatusShown = value;
    },
    changePaymentStatus: function changePaymentStatus(item) {
      this.currentItem = item;
      this.showPaymentStatusDialog(true);
    },
    updatePaymentStatus: function updatePaymentStatus(status, paymentType, paymentDate, paymentReference, isAttachPaymentToAccRecs) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this, data;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this = _this7;
              data = _objectSpread({}, _this7.currentItem);
              data.state = status;
              data.type = paymentType;
              data.paymentDate = paymentDate;
              data.reference = paymentReference;
              if (status === _this.paymentState.SUCCEEDED && isAttachPaymentToAccRecs === true) {
                data.isAttachPaymentToAccRecs = isAttachPaymentToAccRecs;
              }
              _context4.prev = 7;
              _context4.next = 10;
              return request("/v1/payment/".concat(_this7.currentItem.id), "put", data, true, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to change the payment.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                throw e;
              });
            case 10:
              _this7.showPaymentStatusDialog(false);
              _context4.next = 13;
              return _this7.fetchPayments();
            case 13:
              _this7.$nextTick(function () {
                _this7.$toasted.show("Payment status changed.", {
                  type: "success"
                });
              });
              _context4.next = 18;
              break;
            case 16:
              _context4.prev = 16;
              _context4.t0 = _context4["catch"](7);
            case 18:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[7, 16]]);
      }))();
    },
    removePayment: function removePayment(item) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var confirm;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this8.$refs.confirm.open("Remove payment", "Are you sure you want to remove this payment?", {
                width: 380,
                color: "red"
              });
            case 2:
              confirm = _context5.sent;
              if (!confirm) {
                _context5.next = 7;
                break;
              }
              _context5.next = 6;
              return request("/v1/payment/".concat(item.id), "delete", null, true, "api", null).catch(function (e) {
                _this.$toasted.show("Unable to remove this payment.", {
                  type: "error"
                });
                throw e;
              });
            case 6:
              _this8.fetchPayments();
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    isLaunchPaymentAvailable: function isLaunchPaymentAvailable(item) {
      return this.isShowLaunchPayment && ![paymentState.SUCCEEDED].includes(item.state) && ![paymentState.PROCESSING].includes(item.state) && !!item.methodId && !!item.type && paymentTypesWithCN.filter(function (x) {
        return x.isDebitable;
      }).map(function (x) {
        return x.id;
      }).includes(item.type);
    },
    launchPayment: function launchPayment(item) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this9$inboundDeliver;
        var confirm, _this10, tempItem, intervalCount, interval;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this9.currentItem = item;
              _context6.next = 3;
              return _this9.$refs.confirm.open("Launch stripe payment", ((_this9$inboundDeliver = _this9.inboundDelivery.importer) !== null && _this9$inboundDeliver !== void 0 && _this9$inboundDeliver.isPreventingPayment ? "<p class='errorLabel'>WARNING : THE IMPORTER FOR THIS ORDER DISPATCH SHOULD PREVENT PLATFORM PAYMENT.<br />Are you really sure to proceed ?</p>" : "") + "<p>If the payment success, order edition will be blocked. You won't be able to edit any quantity. You won't be able to add or remove any product.</p>", {
                width: 480,
                isHtmlMessage: true
              });
            case 3:
              confirm = _context6.sent;
              if (!confirm) {
                _context6.next = 14;
                break;
              }
              _this9.$EventBus.$emit("loading", true);
              item.isLaunchingPayment = true;
              _this10 = _this9;
              _context6.next = 10;
              return request("/v1/payments", "post", {
                paymentIds: [item.id]
              }, true, "api", null).catch(function () {
                _this10.$toasted.show("Unable to launch payment of this order dispatch.", {
                  type: "error"
                });
              });
            case 10:
              tempItem = _objectSpread({}, _this9.currentItem);
              intervalCount = 0;
              interval = setInterval(function () {
                intervalCount++;
                _this9.fetchPayment(function (fetched) {
                  if (fetched.state !== tempItem.state || intervalCount >= 5) {
                    clearInterval(interval);
                    item.isLaunchingPayment = false;
                    _this10.currentItem = null;
                    _this10.fetchPayments();
                  }
                });
              }, 1000);
              _this9.$EventBus.$emit("loading", false);
            case 14:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    createPaymentLink: function createPaymentLink(item) {
      this.currentItem = item;
      this.paymentLinkDrawerShown = true;
    },
    stateStyleClass: function stateStyleClass() {
      return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, paymentState.SUCCEEDED, "success"), paymentState.PROCESSING, "neutral"), paymentState.ACKNOWLEDGED, "neutral"), paymentState.DEFERRED, "neutral"), paymentState.FAILED, "danger");
    },
    formatPrice: formatPrice,
    getSymbolCurrency: getSymbolCurrency,
    getPublicPaymentStateForAdmins: getPublicPaymentStateForAdmins
  }
};